export default __webpack_public_path__ + "static/media/screen7.366cf21f.png";